import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/allStars_logo_dark.png'
import _imports_1 from '@/assets/img/key-visual.jpg'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "row mx-0 vh-100" }
const _hoisted_3 = { class: "col-lg-7 col-sm-12 d-flex align-items-center justify-content-center loginBg" }
const _hoisted_4 = { class: "bg_grey p-5 position-relative" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "allStarsLogo"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "col-lg-5 d-none d-lg-block position-relative p-0",
  style: {"overflow":"hidden"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "topHalf" }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "logo"
  }),
  /*#__PURE__*/_createVNode("div", { class: "bottomHalf" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_localized_text, {
            type: "h2",
            localizedKey: "backoffice_WelcomeBack",
            text: "Welcome Back",
            class: "text-center white"
          }),
          _createVNode("form", {
            class: "mt-5",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_field, {
              type: "email",
              modelValue: _ctx.languageCredential.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageCredential.username = $event)),
              placeholderKey: "backoffice_Email",
              placeholderValue: "Email",
              labelKey: "backoffice_Email",
              labelValue: "Email"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              class: "pb-3",
              type: "password",
              modelValue: _ctx.languageCredential.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.languageCredential.password = $event)),
              placeholderKey: "backoffice_Password",
              placeholderValue: "Password",
              labelKey: "backoffice_Password",
              labelValue: "Password"
            }, null, 8, ["modelValue"]),
            _createVNode("button", {
              type: "submit",
              class: "primaryButton w-100 mt-5",
              disabled: _ctx.disabled
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "backoffice_Login",
                text: "Login"
              })
            ], 8, ["disabled"])
          ], 32)
        ])
      ]),
      _hoisted_6
    ])
  ]))
}